import React from "react";

const CustomToggleBtn = React.forwardRef(({ children, onClick, customCSSClasses }, ref) => (
  <button
    type="button"
    className={`btn ${customCSSClasses ?? ""}`}
    style={{
      borderRadius: 10,
      width: 38,
      height: 38,
      padding: 0,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#6b7280",
      background: "transparent",
      border: "none",
      fontSize: 16,
      transition: "background 0.15s ease, color 0.15s ease",
    }}
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = "rgba(3,142,220,0.08)";
      e.currentTarget.style.color = "#038edc";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = "transparent";
      e.currentTarget.style.color = "#6b7280";
    }}
  >
    {children}
  </button>
));

  export default CustomToggleBtn;

